import { l } from '@manychat/manyui'

export const SUPPORT_CUTOVER_END = new Date('2026-11-02T15:00:00Z')

/** Cutover end time in the viewer's locale and timezone, e.g. "4:00 PM GMT+1". */
export const formatSupportCutoverEndTime = (
  locale: string = l.getLocale(),
  timeZone?: string,
): string =>
  SUPPORT_CUTOVER_END.toLocaleTimeString(locale, {
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
    timeZone,
  })
